/**
 * Converts a numeric handicap value back to its Chinese term.
 * @param {number|string|null} value - The numeric handicap value (e.g., -0.25, 0.5).
 * @returns {string} - The Chinese handicap term (e.g., "平/半", "受半球").
 */
export function formatHandicap(value) {
  if (value === null || value === undefined || value === '') return '—';
  
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  if (num === 0) return '平手';

  const absNum = Math.abs(num);
  const sign = num > 0 ? '受' : '';

  // Mapping of common values
  const commonMap = {
    0.25: '平/半',
    0.5: '半球',
    0.75: '半/一',
    1.0: '一球',
    1.25: '一/球半',
    1.5: '球半',
    1.75: '球半/兩',
    2.0: '兩球',
    2.25: '兩/兩球半',
    2.5: '兩球半',
    2.75: '兩球半/三',
    3.0: '三球',
    3.25: '三/三球半',
    3.5: '三球半',
    3.75: '三球半/四',
    4.0: '四球'
  };

  if (commonMap[absNum]) {
    return sign + commonMap[absNum];
  }

  // Fallback for uncommon values
  return sign + absNum.toString();
}

/**
 * Converts a numeric goals line (OU) to its standard string representation.
 * @param {number|string|null} value - The numeric goals line (e.g., 2.25, 2.75).
 * @returns {string} - The goals line string (e.g., "2/2.5", "2.5/3").
 */
export function formatGoalsLine(value) {
  if (value === null || value === undefined || value === '') return '—';
  
  const num = parseFloat(value);
  if (isNaN(num)) return value;

  // If it's a split line (ends in .25 or .75)
  if (num % 1 === 0.25) {
    const base = Math.floor(num);
    return `${base}/${base + 0.5}`;
  }
  if (num % 1 === 0.75) {
    const base = Math.floor(num) + 0.5;
    return `${base}/${base + 0.5}`;
  }

  return num.toString();
}
